import React, { Fragment } from "react";
import {
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid
} from "@material-ui/core";

function JoinPath(props) {
  const classes = props.useStyles();
  
  return (
    <Fragment>
      <h4>행사장 방문 경로</h4>
      <FormGroup>
        <Grid container>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.DangunMarketAd}
                  onChange={(e) => props.onChangeDangunMarketAd(e.target.value)}
                  name="dangunmarketAd"
                />
              }
              label="당근마켓 광고"
            />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.AptBoardAd}
                    onChange={(e) => props.onChangeBorderAd(e.target.value)}
                    name="aptBoardAd"
                  />
                }
                label="아파트 게시판 광고"
              />
           </Grid>
           <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.JiinSoge}
                  onChange={(e) => props.onChangeJiinSoge(e.target.value)}
                  name="JiinSoge"
                />
              }
              label="지인 소개"
            />

            </Grid>

            <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.Moonja}
                  onChange={(e) => props.onChangeMoonja(e.target.value)}
                  name="moonja"
                />
              }
              label="문자"
            />

            </Grid>
            <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox checked={props.Etc} onChange={(e) => props.onChangeEtc(e.target.value)} name="etc" />
              }
              label="기타"
            />
    
            </Grid>
            

          </Grid> 
            
        <TextField
          className={classes.TextField}
          disabled={!props.Etc}
          fullWidth
          label="기타 사유"
          type="text"
          multiline={true}
          variant="filled"
          name="etcDetail"
          defaultValue={props.EtcDetail}
          onChange={(e) => {
            e.preventDefault();
            props.onChangeEtcDetail(e.target.value);
          }}
        />
      </FormGroup>
    </Fragment>
  );
}

export default JoinPath;
